<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span>
            Moduły dostępne w systemie dla firmy: <br /><b>{{ companyName }}</b>
          </span>
        </v-card-title>
        <v-card-text>
          <v-checkbox label="Moduł delegacji" hide-details v-model="model.is_module_delegation_enabled" :true-value="2" :false-value="1" />
          <v-checkbox label="Moduł ofertownika" hide-details v-model="model.is_module_travel_service_enabled" :true-value="2" :false-value="1" />
          <v-checkbox label="Moduł eksportu do Optimy" hide-details v-model="model.is_module_optima_enabled" :true-value="2" :false-value="1" />
          <v-checkbox
            label="Moduł podglądu wszystkich bookingów"
            hide-details
            v-model="model.is_module_all_bookings_enabled"
            :true-value="2"
            :false-value="1"
          />
          <v-checkbox
            label="Moduł podglądu bookingów lotniczych"
            hide-details
            v-model="model.is_module_flight_bookings_enabled"
            :true-value="2"
            :false-value="1"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn :disabled="$store.getters['Ajax/loading']" @click="cancel" color="blue darken-1" text>Anuluj</v-btn>
          <v-btn :disabled="$store.getters['Ajax/loading']" @click="save" color="blue darken-1" text>Zapisz</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "CompanyModules",
  data: () => ({
    dialog: false,
    companyName: null,
    model: {
      is_module_delegation_enabled: 1,
      is_module_travel_service_enabled: 1,
      is_module_optima_enabled: 1,
      is_module_all_bookings_enabled: 1,
      is_module_flight_bookings_enabled: 1,
      company_id: null
    }
  }),
  methods: {
    open(companyId, companyName) {
      this.dialog = true;
      this.companyName = companyName;
      this.model.is_module_delegation_enabled = 1;
      this.model.is_module_travel_service_enabled = 1;
      this.model.is_module_optima_enabled = 1;
      this.model.is_module_all_bookings_enabled = 1;
      this.model.is_module_flight_bookings_enabled = 1;
      this.model.company_id = companyId;
      this.axios.get("admin/company-admin/get-company-modules?companyId=" + companyId).then(resp => {
        this.model = resp.data;
      });
    },
    cancel() {
      this.dialog = false;
    },
    save() {
      this.axios.post("admin/company-admin/save-company-modules", this.model).then(() => {
        this.dialog = false;
        this.$store.dispatch("snackbarPush", {
          text: this.$t("global.saved"),
          position: "down"
        });
      });
    }
  }
};
</script>

<style scoped></style>
